import DateField from "../../../../../../components/DateField";
import {Card, CardContent, Grid, TextField, Typography} from "@material-ui/core";
import React, {FC} from "react";
import AlertCompanyAPIKey from "../components/AlertCompanyAPIKey";
import {calculateDaysLeft} from "../../../../../../utils/functions";
import {Alert} from "@mui/material";

type PropsType = {
  values: any
  setFieldValue: (field: string, value: any) => void,
  handleChange: {(e: React.ChangeEvent<any>): void, <T_1=string | React.ChangeEvent<any>>(field: T_1): T_1 extends React.ChangeEvent<any> ? void : ((e: (string | React.ChangeEvent<any>)) => void)}
  errors: any
  touched: any
}

const CompanyAPIKeySection: FC<PropsType> = ({
  values,
  setFieldValue,
  handleChange,
  errors,
  touched
}) => {
  return (
    <Card>
      <CardContent>
        <Typography variant="h6" style={{ marginBottom: "20px" }}>
          4. Company API Key
        </Typography>
        <Grid container spacing={4}>
          <Grid item xs={6}>
            <TextField
              name={`company_api_key.name`}
              label={'Name'}
              onChange={handleChange}
              value={values.company_api_key ? values.company_api_key.name : ''}
              helperText={!!errors.company_api_key?.name && !!touched.company_api_key?.name && errors.company_api_key?.name}
              error={!!errors.company_api_key?.name && !!touched.company_api_key?.name}
              fullWidth
              variant={'outlined'}
            />
          </Grid>
          <Grid item xs={6}>
            {values.company_api_key && values.company_api_key.key ? (
                <AlertCompanyAPIKey companyAPIKey={values.company_api_key.key}/>
            ) : null}
          </Grid>
          <Grid item xs={6}>
            <DateField
              label={'Expires date'}
              name={'company_api_key.expiry_date'}
              value={values.company_api_key ? values.company_api_key.expiry_date : ''}
              helperText={!!errors.company_api_key?.expiry_date && !!touched.company_api_key?.expiry_date && errors.company_api_key?.expiry_date}
              error={!!errors.company_api_key?.expiry_date && !!touched.company_api_key?.expiry_date}
              onChange={(value) => {
                setFieldValue(`company_api_key.expiry_date`, value)
              }}
              fullWidth
            />
          </Grid>
          <Grid item xs={6}>
            {values.company_api_key && values.company_api_key.key ? (
              <Alert icon={false} severity={'warning'} style={{padding: '7.5px 16px', backgroundColor: 'rgb(0 0 0 / 11%)'}}>
                <Typography style={{fontWeight: 'bold', color: '#FFF'}}>
                  {calculateDaysLeft(values.company_api_key.expiry_date)} days left
                </Typography>
              </Alert>
            ) : null}
          </Grid>
        </Grid>
      </CardContent>
    </Card>
  )
}

export default CompanyAPIKeySection
